import { FC, useCallback, useState } from 'react'
import { Outlet, useNavigate, useOutletContext } from 'react-router-dom'

// COMPONENTS
import Toast, { IToast } from '@components/molecules/toast'

// ROUTES
import { PhoneIdRoute } from './[phoneId]'
import { AddPhoneRoute } from './add'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES


type ProfilePhoneContext = { setToast: (toast: IToast | undefined) => void }
export const useProfilePhoneContext = () => useOutletContext<ProfilePhoneContext>()

const Component: FC<{}> = () => {
    const navigate = useNavigate()
    const [toast, setT] = useState<IToast>()
    const setToast = useCallback((toast: IToast | undefined) => { setT(toast) }, [setT])

    function handleBack() {
        navigate(-1)
    }

    return (<>
        <a onClick={handleBack}>
            <img src="/icons/arrow-left.svg" alt="back" style={{ width: '1.4rem', height: '1.4rem' }} draggable="false" />
        </a>
        <div className="temp-card">
            <Outlet context={{ setToast } satisfies ProfilePhoneContext} />
        </div>
        <Toast toast={toast} />
    </>)
}

const PhoneRoute: RouteObject = {
    path: "phone",
    Component,
    children: [
        PhoneIdRoute,
        AddPhoneRoute,
    ],
}

export { PhoneRoute }